import createIcon from '../../createIcon';

/**
 * @component @name SportsScore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNkg5VjRIMTFWNlpNMTUgNEgxM1Y2SDE1VjRaTTkgMTRIMTFWMTJIOVYxNFpNMTkgMTBWOEgxN1YxMEgxOVpNMTkgMTRWMTJIMTdWMTRIMTlaTTEzIDE0SDE1VjEySDEzVjE0Wk0xOSA0SDE3VjZIMTlWNFpNMTMgOFY2SDExVjhIMTNaTTcgMTBWOEg5VjZIN1Y0SDVWMjBIN1YxMkg5VjEwSDdaTTE1IDEySDE3VjEwSDE1VjEyWk0xMSAxMFYxMkgxM1YxMEgxMVpNOSA4VjEwSDExVjhIOVpNMTMgMTBIMTVWOEgxM1YxMFpNMTUgNlY4SDE3VjZIMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsScore = createIcon('SportsScore', [
  [
    'path',
    {
      d: 'M11 6H9V4H11V6ZM15 4H13V6H15V4ZM9 14H11V12H9V14ZM19 10V8H17V10H19ZM19 14V12H17V14H19ZM13 14H15V12H13V14ZM19 4H17V6H19V4ZM13 8V6H11V8H13ZM7 10V8H9V6H7V4H5V20H7V12H9V10H7ZM15 12H17V10H15V12ZM11 10V12H13V10H11ZM9 8V10H11V8H9ZM13 10H15V8H13V10ZM15 6V8H17V6H15Z',
      key: '166sua',
    },
  ],
]);

export default SportsScore;
